import React from 'react';
import { ExpandableChips } from '@/components/table/DataGridComponents/ExpandableChips';
import { BrokerGroupChip } from './BrokerGroupChip';

/**
 * Broker groups (brokerGroupIds) as chips in a table cell, e.g. a user's other broker groups
 * or who a form field config is shared with: one line with "+x" that expands
 * (ExpandableChips).
 */
export const BrokerGroupChipsCell = ({ brokerGroupIds }) => (
	<ExpandableChips
		items={brokerGroupIds}
		renderChip={(id) => <BrokerGroupChip key={id} id={id} />}
		itemsLabel='broker groups'
	/>
);

BrokerGroupChipsCell.displayName = 'BrokerGroupChipsCell';
